import React from 'react'
import { Button } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

export const CopyButton: React.FC<{ copyText: string }> = ({ copyText }) => {
  const { t } = useTranslation(['common'])
  return (
    <Button
      title={t('common:copy')}
      icon="copy"
      secondary
      className="flex items-center justify-center size-8 border-2 rounded-md border-brand-6"
      onClick={() => navigator.clipboard.writeText(copyText)}
    />
  )
}
